(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdc-customer-flows"] && !Shopify.designMode) return;
  try {
    function initializeMdcFlows(){document.querySelectorAll('[data-mdc-flow]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const quiz=root.querySelector('[data-quiz]');if(quiz){const results=root.querySelector('[data-results]');quiz.addEventListener('submit',event=>{event.preventDefault();const scores={keto:0,mediterranean:0,high_protein:0,fiber:0};new FormData(quiz).forEach(value=>{if(Object.hasOwn(scores,value))scores[value]++});const highest=Math.max(...Object.values(scores));const winners=Object.keys(scores).filter(key=>scores[key]===highest);root.querySelectorAll('[data-result]').forEach(card=>{card.hidden=!winners.includes(card.dataset.result)});root.querySelector('[data-tie]').hidden=winners.length<2;quiz.hidden=true;results.hidden=false;root.querySelector('[data-result-heading]').focus()});root.querySelector('[data-restart]').addEventListener('click',()=>{results.hidden=true;quiz.hidden=false;quiz.reset();quiz.querySelector('input').focus()})}const guide=root.querySelector('#MdcGuide');if(guide){const choice=new URLSearchParams(location.search).get('guide');if(['keto','mediterranean','high_protein','fiber'].includes(choice))guide.value='newsletter,mdc-guide-'+choice}})}initializeMdcFlows();document.addEventListener('shopify:section:load',initializeMdcFlows);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mdc-recipe"]) return;
  try {
    
function initializeMdcRecipes(root = document) {
  root.querySelectorAll('.mdc-recipe__card').forEach(card => {
    if (card.dataset.initialized) return;
    card.dataset.initialized = 'true';
    const print = card.querySelector('.mdc-recipe__print');
    print.hidden = false;
    print.addEventListener('click', () => {
      const sheet = window.open('', '_blank');
      if (!sheet) { window.print(); return; }
      const copy = card.cloneNode(true);
      copy.querySelectorAll('script,button,fieldset,.mdc-recipe__scaling-note,.mdc-recipe__sr-only,.mdc-recipe__eyebrow,.mdc-recipe__nutrition > p,.mdc-recipe__nutrition details').forEach(node => node.remove());
      const doc = sheet.document;
      doc.open();
      doc.write('<!doctype html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><title></title></head><body></body></html>');
      doc.close();
      doc.title = card.querySelector('h2').textContent;
      doc.documentElement.lang = document.documentElement.lang || 'en';
      const style = doc.createElement('style');
      style.textContent = `
        @page { size: auto; margin: 13mm; }
        * { box-sizing:border-box; }
        body { max-width:7.4in; margin:20px auto; padding:0 18px; color:#111; background:#fff; font:10.5pt/1.4 Arial,sans-serif; }
        .print-toolbar { margin:0 0 20px; padding-bottom:12px; border-bottom:1px solid #ddd; }
        .print-toolbar button { padding:10px 18px; font:14px Arial,sans-serif; cursor:pointer; }
        .mdc-recipe__print-brand { font-size:10pt; font-weight:bold; margin:0 0 9pt; border-bottom:1pt solid #333; padding-bottom:6pt; }
        h2 { font-size:21pt; line-height:1.12; margin:0 0 10pt; break-after:avoid; }
        h3 { font-size:11pt; margin:0 0 7pt; break-after:avoid; }
        .mdc-recipe__stats { display:flex; flex-wrap:wrap; gap:24pt; padding:7pt 0; margin:0 0 12pt; border-block:1px solid #ccc; }
        dt { font-size:8pt; } dd { margin:2pt 0 0; font-weight:bold; }
        .mdc-recipe__columns { display:grid; grid-template-columns:.9fr 1.6fr; gap:22pt; }
        ul,ol { margin:0; padding-left:16pt; } li { margin:0 0 6pt; padding-left:2pt; break-inside:avoid; }
        .mdc-recipe__nutrition { margin:12pt 0 0; padding:9pt 0; border-block:1px solid #bbb; break-inside:avoid; }
        .mdc-recipe__nutrition h3 { font-size:9pt; }
        .mdc-recipe__nutrition dl { display:flex; flex-wrap:wrap; gap:12pt; margin:0; }
        .mdc-recipe__nutrition dt,.mdc-recipe__nutrition dd { display:inline; font-size:8.5pt; margin:0; }
        .mdc-recipe__nutrition dd { margin-left:3pt; }
        .mdc-recipe__tip { margin-top:10pt; font-size:9pt; break-inside:avoid; }
        .mdc-recipe__tip p { margin:3pt 0 0; }
        @media print { body { max-width:none; margin:0; padding:0; } .print-toolbar { display:none; } }
        @media screen and (max-width:550px) { .mdc-recipe__columns { display:block; } .mdc-recipe__columns > div { margin-bottom:16px; } }
      `;
      doc.head.append(style);
      const toolbar = doc.createElement('div'); toolbar.className = 'print-toolbar';
      const retry = doc.createElement('button'); retry.type = 'button'; retry.textContent = print.textContent;
      retry.addEventListener('click', () => sheet.print()); toolbar.append(retry);
      doc.body.append(toolbar,doc.importNode(copy,true));
      sheet.focus();
      sheet.setTimeout(() => sheet.print(), 250);
    });
    const data = card.querySelector('.mdc-recipe__portions');
    if (!data) return;
    const portions = JSON.parse(data.textContent);
    const controls = card.querySelector('.mdc-recipe__servings');
    const renderList = (selector, entries) => {
      card.querySelector(selector).replaceChildren(...entries.map(text => {
        const item = document.createElement('li'); item.textContent = text; return item;
      }));
    };
    controls.hidden = false;
    controls.querySelectorAll('button').forEach(button => button.addEventListener('click', () => {
      const servings = button.dataset.servings;
      if (!portions[servings]) return;
      renderList('[data-recipe-ingredients]', portions[servings].ingredients);
      renderList('[data-recipe-steps]', portions[servings].steps);
      card.querySelector('[data-serving-count]').textContent = servings;
      controls.querySelectorAll('button').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      const status = card.querySelector('[data-serving-status]');
      status.textContent = status.dataset.message.replace('[count]', servings);
    }));
  });
}
initializeMdcRecipes();
document.addEventListener('shopify:section:load', event => initializeMdcRecipes(event.target));

  } catch(e) { console.error(e); }
})();
})();
